import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon52: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M12.5 0C12.776 0 13 0.224 13 0.5V2H15.5C15.745 2 15.95 2.177 15.992 2.41L16 2.5V6.987C16 8.099 15.099 9 13.987 9H13V10C13 12.615 11.004 14.654 8.501 14.886V18.496C9.954 18.531 11.353 18.709 12.617 19.014C12.886 19.079 13.051 19.349 12.986 19.617C12.921 19.886 12.651 20.051 12.383 19.986C11.04 19.662 9.529 19.489 7.959 19.489L8.092 19.492C8.062 19.497 8.031 19.5 8 19.5C7.968 19.5 7.936 19.497 7.905 19.491C6.403 19.493 4.967 19.665 3.616 19.986C3.347 20.05 3.078 19.884 3.014 19.616C2.95 19.347 3.116 19.078 3.384 19.014C4.828 18.67 6.36 18.489 7.959 18.489L7.5 18.495L7.501 14.882C7.323 14.864 7.144 14.837 6.963 14.801C4.608 14.327 3 12.388 3 10V9H2.013C0.951 9 0.0819967 8.17899 0.0059967 7.13699L0 6.987V2.5C0 2.224 0.224 2 0.5 2H3V0.5C3 0.224 3.224 0 3.5 0H12.5ZM12 1H4V10C4 11.909 5.27 13.44 7.161 13.821C9.717 14.335 12 12.498 12 10V1ZM13 8H13.987C14.547 8 15 7.547 15 6.987V3H13V8ZM3 8V3H1V6.987C1 7.547 1.453 8 2.013 8H3Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
